import React from 'react';
import styled from 'styled-components';
import { Theme } from '@routific/hive';
import RouteCheckbox from '../RouteCheckbox';
import RouteNameText from '../RouteNameText';

interface Props {
  name: string | null | undefined;
  showCheckbox?: boolean;
  isChecked?: boolean;
  onCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: 'title' | 'body';
  routeUuid?: string;
}

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Theme.Spacing.smSpacing};
  min-width: 0;
  width: 100%;
`;

const RouteNameWithStatus: React.FC<Props> = ({
  name,
  showCheckbox = false,
  isChecked = false,
  onCheckboxChange,
  variant = 'body',
  routeUuid,
}) => {
  const shouldShowCheckbox = showCheckbox && routeUuid && onCheckboxChange;

  return (
    <NameContainer>
      {shouldShowCheckbox && (
        <RouteCheckbox
          checked={isChecked}
          value={routeUuid}
          onChange={onCheckboxChange}
        />
      )}
      {name && <RouteNameText name={name} variant={variant} />}
    </NameContainer>
  );
};

export default RouteNameWithStatus;
